import api from "../../utils/api";

export const state = {
  dealList: [],
  currentDeal: null,
  parties: [],
  dealRole: null,
  directDealSeq: null,
};

export const mutations = {
  SET_DEAL_LIST(state, data) {
    state.dealList = data;
  },
  SET_CURRENT_DEAL(state, data) {
    state.currentDeal = data;
  },
  SET_PARTIES(state, data) {
    state.parties = data;
  },
  SET_DEAL_ROLE(state, data) {
    state.dealRole = data;
  },
  SET_DIRECT_DEAL_SEQ(state, data) {
    state.directDealSeq = data;
  },
  CLEAR_DEAL(state) {
    state.currentDeal = null;
    state.parties = [];
    state.dealRole = null;
    state.directDealSeq = null;
  },
};

export const actions = {
  // POST /api/v1/direct-deal
  async acCreateDeal(_, { dealRole }) {
    const result = await api.post("/api/v1/direct-deal", { dealRole });
    return result?.data?.data || null;
  },

  // GET /api/v1/direct-deal?user_no=xxx
  async acGetDealList({ commit }) {
    const result = await api.get("/api/v1/direct-deal");
    const list = result?.data?.data || [];
    commit("SET_DEAL_LIST", list);
    return list;
  },

  // GET /api/v1/direct-deal/:seq
  async acGetDealDetail({ commit }, directDealSeq) {
    const result = await api.get("/api/v1/direct-deal/" + directDealSeq);
    const detail = result?.data?.data || {};
    commit("SET_CURRENT_DEAL", detail.deal || null);
    commit("SET_PARTIES", detail.parties || []);
    commit("SET_DIRECT_DEAL_SEQ", directDealSeq);
    if (detail.deal && detail.deal.dealRole) {
      commit("SET_DEAL_ROLE", detail.deal.dealRole);
    }
    return detail;
  },

  // PATCH /api/v1/direct-deal/:seq/step
  async acUpdateStep({ commit }, { directDealSeq, currentStep }) {
    const result = await api.patch("/api/v1/direct-deal/" + directDealSeq + "/step", {
      currentStep,
    });
    const deal = result?.data?.data || null;
    commit("SET_CURRENT_DEAL", deal);
    return deal;
  },

  // POST /api/v1/direct-deal/:seq/party
  async acSaveParty(
    _,
    { directDealSeq, partyRole, partyType, name, phone, birthDate, sortOrder, verifySeq },
  ) {
    var body = {
      partyRole,
      partyType,
      name,
      phone,
      birthDate,
      sortOrder,
    };
    if (verifySeq) body.verifySeq = verifySeq;
    const result = await api.post("/api/v1/direct-deal/" + directDealSeq + "/party", body);
    return result?.data?.data || null;
  },

  // DELETE /api/v1/direct-deal/:seq/party/:partySeq
  async acRemoveParty(_, { directDealSeq, partySeq }) {
    await api.delete("/api/v1/direct-deal/" + directDealSeq + "/party/" + partySeq);
  },

  // PATCH /api/v1/direct-deal/:seq/party/:partySeq
  async acUpdatePartyPhone(_, { directDealSeq, partySeq, phone, name }) {
    var body = { phone };
    if (name !== undefined) body.name = name;
    const result = await api.patch(
      "/api/v1/direct-deal/" + directDealSeq + "/party/" + partySeq,
      body,
    );
    return result?.data?.data || null;
  },

  // POST /api/v1/direct-deal/:seq/property (deal에 직접 저장됨)
  async acSaveProperty({ commit }, { directDealSeq, ...propertyData }) {
    const result = await api.post(
      "/api/v1/direct-deal/" + directDealSeq + "/property",
      propertyData,
    );
    const deal = result?.data?.data || null;
    commit("SET_CURRENT_DEAL", deal);
    return deal;
  },

  // POST /api/v1/direct-deal/:seq/transaction (deal에 직접 저장됨)
  async acSaveTransaction({ commit }, { directDealSeq, ...transactionData }) {
    const result = await api.post(
      "/api/v1/direct-deal/" + directDealSeq + "/transaction",
      transactionData,
    );
    const deal = result?.data?.data || null;
    commit("SET_CURRENT_DEAL", deal);
    return deal;
  },

  // DELETE /api/v1/direct-deal/:seq (취소)
  async acCancelDeal(_, directDealSeq) {
    await api.delete("/api/v1/direct-deal/" + directDealSeq);
  },

  // POST /api/v1/direct-deal/:seq/consent/send (동의 요청 발송)
  async acSendConsent(_, directDealSeq) {
    const result = await api.post("/api/v1/direct-deal/" + directDealSeq + "/consent/send", {});
    return result?.data?.data || null;
  },

  // PATCH /api/v1/direct-deal/:seq/consent/:partySeq (동의 응답)
  async acRespondConsent(_, { directDealSeq, partySeq, status }) {
    const result = await api.patch(
      "/api/v1/direct-deal/" + directDealSeq + "/consent/" + partySeq,
      { status },
    );
    return result?.data?.data || null;
  },

  // POST /api/v1/direct-deal/:seq/consent/:partySeq/resend (동의 재발송)
  async acResendConsent(_, { directDealSeq, partySeq }) {
    const result = await api.post(
      "/api/v1/direct-deal/" + directDealSeq + "/consent/" + partySeq + "/resend",
      {},
    );
    return result?.data?.data || null;
  },

  // POST /api/v1/direct-deal/:seq/consent/:partySeq/verify (본인인증 검증)
  async acVerifyConsentIdentity(_, { directDealSeq, partySeq, verifySeq }) {
    try {
      const result = await api.post(
        "/api/v1/direct-deal/" + directDealSeq + "/consent/" + partySeq + "/verify",
        { verifySeq },
      );
      console.log("[acVerifyConsentIdentity] response:", result?.data);
      return result?.data?.data || null;
    } catch (err) {
      console.error(
        "[acVerifyConsentIdentity] error:",
        err?.response?.status,
        err?.response?.data || err.message,
      );
      return null;
    }
  },

  // GET /api/v1/direct-deal/:seq/consent (동의 상태 조회 - 인증 없이)
  async acGetConsentStatus({ commit }, directDealSeq) {
    const result = await api.get("/api/v1/direct-deal/" + directDealSeq + "/consent");
    const detail = result?.data?.data || {};
    commit("SET_CURRENT_DEAL", detail.deal || null);
    commit("SET_PARTIES", detail.parties || []);
    return detail;
  },
};

export const getters = {
  applicant: state => state.parties.find(p => p.partyType === "APPLICANT") || null,
  coApplicants: state => state.parties.filter(p => p.partyType === "CO_APPLICANT"),
  counterparts: state => state.parties.filter(p => p.partyType === "COUNTERPART"),
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
